import { Button } from "@mui/material";
import strings from "global/constants/StringConstants";
import ScrollHintRail from "global/components/ScrollHintRail/ScrollHintRail";
import signRequestsStyles from "../SignRequests.styles";

const styles = signRequestsStyles;

/**
 * Status pills above the list.
 *
 * Carries the full sent-request status set the screen filtered by before the
 * re-skin (`RequestStatusOptions` in `MySignRequestHelper`) — the design only
 * drew a subset. Each tab maps 1:1 onto a status the folder API serves, since
 * it filters by a single `status` value. "Completed" keeps the design's
 * wording for the app's `Signed` status.
 *
 * Ten pills never fit a phone, so the strip scrolls; `ScrollHintRail` supplies
 * the chevron at whichever end still has pills beyond it.
 */
/**
 * Not a status — the one pill that switches the list to bulk batches instead of
 * envelopes, so a 500-recipient send reads as one row. The folder API is never
 * called with this value; `SentRequestsFolderView` swaps the view instead.
 */
export const BATCHES_TAB = "Batches";

export const SIGN_REQUESTS_TABS: { label: string; value: string }[] = [
  { label: "All", value: "All" },
  { label: BATCHES_TAB, value: BATCHES_TAB },
  { label: strings.draft, value: strings.draft },
  { label: strings.pending, value: strings.pending },
  { label: strings.inReviewLabel, value: strings.inReview },
  { label: strings.scheduled, value: strings.scheduled },
  { label: "Completed", value: strings.signed },
  { label: strings.declined, value: strings.declined },
  { label: strings.rejected, value: strings.rejected },
  { label: strings.voided, value: strings.voided },
  { label: strings.expired, value: strings.expired },
];

interface SignRequestsFilterTabsProps {
  value: string;
  disabled: boolean;
  onChange: (value: string) => void;
}

const SignRequestsFilterTabs = ({
  value,
  disabled,
  onChange,
}: SignRequestsFilterTabsProps) => (
  <ScrollHintRail
    sx={styles.tabsRail}
    railSx={styles.tabs}
    previousLabel="Show previous filters"
    nextLabel="Show more filters"
  >
    {SIGN_REQUESTS_TABS.map((tab) => {
      const active = value === tab.value;
      return (
        <Button
          key={tab.value}
          disableRipple
          disabled={disabled}
          onClick={() => onChange(tab.value)}
          sx={styles.tab(active)}
        >
          {tab.label}
        </Button>
      );
    })}
  </ScrollHintRail>
);

export default SignRequestsFilterTabs;
